module.exports = __webpack_public_path__ + "img/about_qrcode_mulu.72e26d2b.jpg";